export const getOS = (userAgent: string) => {
  if (userAgent.match(/Win(dows )?/)) {
    return 'Windows';
  } else if (userAgent.match(/iPad|iPhone|iPod/)) {
    return 'iOS';
  } else if (userAgent.match(/Android/)) {
    return 'Android';
  } else if (userAgent.match(/Mac|PPC/)) {
    return 'Mac';
  } else if (userAgent.match(/Linux/)) {
    return 'Linux';
  } else if (userAgent.match(/(Free|Net|Open)BSD/)) {
    return RegExp.$1 + 'BSD';
  } else if (userAgent.match(/SunOS/)) {
    return 'Solaris';
  }
  return 'Unknown';
};
